export interface FieldsProps {
  id: string;
  text_value: string;
  x: string;
  y: string;
  width: string;
  height: string;
  type: string;
}

export const fields: FieldsProps[] = [
  {
    id: "rect-sign-Element-156705112478",
    x: "156.705",
    y: "1124.78",
    width: "68",
    height: "68",
    type: "initial",
    text_value: "",
  },

  {
    id: "rect-sign-Element-136705237711",
    x: "136.705",
    y: "2377.11",
    width: "68",
    height: "68",
    type: "initial",
    text_value: "",
  },

  {
    id: "rect-sign-Element-187705315344",
    x: "535.705",
    y: "3166.9399999999987",
    width: "242.89999999999935",
    height: "50.4",
    type: "signature",
    text_value: "",
  },
  {
    id: "rect-sign-Element-285705193",
    x: "285.705",
    y: "213.8999999999999",
    width: "237.8",
    height: "39.09999999999997",
    type: "text",
    text_value: "Nome",
  },
  {
    id: "rect-sign-Element-165705671",
    x: "165.705",
    y: "671",
    width: "241.1",
    height: "33.59999999999997",
    type: "text",
    text_value: "Conteudo do contrato",
  },
];
